import _ from 'lodash';

export function zaokrouhliNc(value: number, presnost: number): number {
	let rounded = 0;
	const absVal = Math.abs(value);
	if (absVal > 0) {
		rounded = Math.round(absVal * (10 ** presnost) + Number.EPSILON) / (10 ** presnost);
		rounded *= absVal / value;
	}
	return rounded;
}

export function zaokrouhli(value: number, presnost: number): number {
	return round(value, 10 ** presnost);
}

function round(value: number, precision: number): number {
	return Math.round((value + Number.EPSILON) * precision) / precision;
}

export function addPercentage(val: number, percent: number): number {
	return (val + (val / 100 * percent));
}

export function getMonths() {
	return _.map(_.range(1, 13), (item) => ({ Text: item, Value: item }));
}

export function get24Hours() {
	return _.map(_.range(1, 25), (item) => ({ Text: item, Value: item }));
}

export function getDays() {
	return _.map(_.range(1, 31), (item) => ({ Text: item, Value: item }));
}

export function isArrayDescending(arrInput: number[]) {
	return arrInput.slice(1).every((e, i) => e! <= arrInput[i]);
}
